<div class="success-wrapper">
    <h2>{{'success' | translate}}</h2>
    <img src="/assets/img/success.svg" alt="" >
    <h4>{{'wizard.scheduled' | translate}}</h4>
    <a [routerLink]="['/planned']">{{'wizard.back' | translate}}</a>
</div>
